const GooglePlayLogo = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="97" height="24" viewBox="0 0 97 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.4796 5.4C49.9717 5.4 48.7494 4.1912 48.7494 2.7C48.7494 1.2088 49.9717 0 51.4796 0C52.9874 0 54.2098 1.2088 54.2098 2.7C54.2098 4.1912 52.9874 5.4 51.4796 5.4ZM51.4796 4.575C52.5267 4.575 53.3755 3.7355 53.3755 2.7C53.3755 1.6645 52.5267 0.825 51.4796 0.825C50.4325 0.825 49.5836 1.6645 49.5836 2.7C49.5836 3.7355 50.4325 4.575 51.4796 4.575ZM32.9749 4.65V3H34.9467V2.4H32.9749V0.825H35.1742V0.224999H32.1406V0.3V5.25H32.9749H35.1742V4.65H32.9749ZM38.1319 0.825V5.25H37.2977V0.825H36.0084V0.224999H39.4212V0.825H38.1319ZM45.5641 5.25V0.825H46.8534V0.224999H43.4406V0.825H44.7299V5.25H45.5641Z"
        fill="white"
      />
      <path d="M42.6819 0.225037H41.8477V5.25004H42.6819V0.225037Z" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.4893 2.48781H30.8221H29.0145V3.20261H30.7894C30.6231 4.17341 29.9297 4.63241 29.0032 4.63241C27.9353 4.63241 27.0696 3.77731 27.0696 2.72231C27.0696 1.66741 27.9353 0.812212 29.0032 0.812212C29.5374 0.812212 30.0005 0.992712 30.3265 1.32201L30.8491 0.805712C30.4046 0.342012 29.7542 0.0750122 28.9806 0.0750122C27.5006 0.0750122 26.3008 1.26031 26.3008 2.72231C26.3008 4.18441 27.5006 5.36761 28.9806 5.36971C30.4854 5.38311 31.7404 4.33481 31.4895 2.51431L31.4893 2.48781ZM55.8779 0.225012H55.7263H54.892V5.25001H55.7263V1.32801L58.1531 5.25001H58.9873V0.225012H58.1531V3.90181L55.8779 0.225012Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.9236 9.22498H73.624V15.6795H77.9236C77.9236 15.6795 80.3987 15.263 80.3987 12.4522C80.3987 9.64148 77.9236 9.22498 77.9236 9.22498ZM74.4583 14.25V10.7863H77.377C77.377 10.7863 78.7052 10.7863 78.7052 12.5181C78.7052 14.25 77.377 14.25 77.377 14.25H74.4583Z"
        fill="white"
      />
      <path d="M74.7619 9.22498H73.2451V19.725H74.7619V9.22498Z" fill="white" />
      <path d="M82.801 9.22498H81.2842V19.725H82.801V9.22498Z" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69.8495 15.4294L65.0524 17.39C65.0524 17.39 65.3622 18.4745 66.8045 18.4817C67.9338 18.4874 68.5714 17.4918 68.5714 17.4918L69.7885 18.3069C69.7885 18.3069 68.8063 19.8777 66.7949 19.8777C64.3231 19.8777 63.2344 17.7403 63.2344 16.3521C63.2344 15.0147 64.0985 12.75 66.6415 12.75C69.1845 12.75 69.8495 15.4294 69.8495 15.4294ZM88.4226 18.9743C88.0049 19.3151 87.337 19.636 86.282 19.7011C83.8653 19.8504 83.8641 17.6695 83.8641 17.5224L83.8636 17.4974C83.8578 17.2368 83.821 15.5855 85.6673 15.314C87.0286 15.1138 87.982 15.4474 88.4226 15.6592V15.3507C88.3146 14.9421 87.9793 14.1913 86.974 14.1913C85.5929 14.1913 85.2879 14.9298 85.2879 14.9298L84.0245 14.1913C84.0245 14.1913 84.7315 12.75 86.8528 12.75C89.4903 12.75 89.9393 14.5492 89.9393 15.1552V15.164V19.7216H88.4226V18.9743ZM88.3143 16.7252C88.3143 16.7252 85.3922 15.9463 85.2906 17.5697C85.189 19.1932 88.094 18.4136 88.3535 17.2628C88.3535 16.8969 88.3143 16.7252 88.3143 16.7252ZM90.0813 12.975L92.7853 19.3266L91.3703 22.65H92.8873L96.9913 13.0113H95.4743L93.5443 17.5453L91.5983 12.975H90.0813ZM66.4951 14.1334C67.4207 13.9659 68.0243 14.874 68.0243 14.874L64.7835 16.1821C64.7835 16.1821 64.5371 14.4876 66.4951 14.1334Z"
        fill="white"
      />
      <path d="M62.5637 9.22498H60.959V19.7032H62.5637V9.22498Z" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.9084 19.875C38.9144 19.875 37.2979 18.28 37.2979 16.3125C37.2979 14.345 38.9144 12.75 40.9084 12.75C42.9024 12.75 44.5189 14.345 44.5189 16.3125C44.5189 18.28 42.9024 19.875 40.9084 19.875ZM48.7197 19.875C46.7257 19.875 45.1092 18.28 45.1092 16.3125C45.1092 14.345 46.7257 12.75 48.7197 12.75C50.7137 12.75 52.3302 14.345 52.3302 16.3125C52.3302 18.28 50.7137 19.875 48.7197 19.875ZM59.8751 12.9904L58.3918 12.9777V13.6316C58.3918 13.6316 57.7469 12.7138 56.4053 12.7511C54.7304 12.7977 52.9966 14.0779 52.9966 16.3161C52.9966 18.5543 54.8379 19.8672 56.3874 19.8672C57.8166 19.8672 58.3919 18.9766 58.3919 18.9766V19.6941C58.3919 20.2062 58.1978 21.7024 56.5349 21.7024C55.0746 21.7024 54.659 20.4096 54.659 20.4096L53.2968 20.9762C53.2968 20.9762 54.07 23.0739 56.4641 23.0739C58.8582 23.0739 59.8751 21.2908 59.8751 19.6017V12.9904ZM58.4726 16.335C58.4726 17.5438 57.5958 18.5237 56.5141 18.5237C55.4323 18.5237 54.5554 17.5438 54.5554 16.335C54.5554 15.1262 55.4323 14.1463 56.5141 14.1463C57.5958 14.1463 58.4726 15.1262 58.4726 16.335ZM50.7256 16.3125C50.7256 17.5084 49.817 18.4779 48.6962 18.4779C47.5754 18.4779 46.6668 17.5084 46.6668 16.3125C46.6668 15.1166 47.5754 14.1471 48.6962 14.1471C49.817 14.1471 50.7256 15.1166 50.7256 16.3125ZM42.9142 16.3125C42.9142 17.5084 42.0056 18.4779 40.8848 18.4779C39.764 18.4779 38.8554 17.5084 38.8554 16.3125C38.8554 15.1166 39.764 14.1471 40.8848 14.1471C42.0056 14.1471 42.9142 15.1166 42.9142 16.3125Z"
        fill="white"
      />
      <path d="M31.585 13.8795H36.3515L36.3045 15.3698H31.585V13.8795Z" fill="white" />
      <path
        d="M35.4141 10.3731L34.3234 11.4494C33.643 10.763 32.6767 10.3868 31.5618 10.3868C29.3332 10.3868 27.5265 12.1694 27.5265 14.3684C27.5265 16.5674 29.3332 18.35 31.5618 18.35C33.7904 18.35 35.3727 17.0787 35.3693 14.3684C35.3731 14.2009 35.3692 14.0378 35.3578 13.8794H36.7502C36.7504 13.8978 36.7505 13.9163 36.7505 13.9348C37.2742 17.7296 34.655 19.9147 31.5146 19.8868C28.4258 19.8824 25.9219 17.4161 25.9219 14.3684C25.9219 11.3207 28.4258 8.84998 31.5146 8.84998C33.1291 8.84998 34.4863 9.40658 35.4141 10.3731Z"
        fill="white"
      />
      <path
        d="M18.3614 9.71481C19.5085 10.36 19.5087 11.4059 18.3614 12.0513L2.077 21.2112C0.9299 21.8564 0 21.3223 0 20.0176V1.74882C0 0.444395 0.9296 -0.0901857 2.077 0.555114L18.3614 9.71481Z"
        fill="url(#paint0_linear_756_114135)"
      />
      <mask id="mask0_756_114135" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="22">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.3614 9.71481C19.5085 10.36 19.5087 11.4059 18.3614 12.0513L2.077 21.2112C0.9299 21.8564 0 21.3223 0 20.0176V1.74882C0 0.444395 0.9296 -0.0901857 2.077 0.555114L18.3614 9.71481Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_756_114135)">
        <path
          d="M-0.0151434 0.292542L10.5865 10.713L-0.152344 21.5445L-0.0151434 0.292542Z"
          fill="url(#paint1_linear_756_114135)"
        />
      </g>
      <mask id="mask1_756_114135" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="22">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.3614 9.71481C19.5085 10.36 19.5087 11.4059 18.3614 12.0513L2.077 21.2112C0.9299 21.8564 0 21.3223 0 20.0176V1.74882C0 0.444395 0.9296 -0.0901857 2.077 0.555114L18.3614 9.71481Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_756_114135)">
        <path
          d="M-2.19531 -1.85248L10.5851 10.716L14.3846 7.13101L-2.19531 -1.85248Z"
          fill="url(#paint2_linear_756_114135)"
        />
      </g>
      <mask id="mask2_756_114135" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="22">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.3614 9.71481C19.5085 10.36 19.5087 11.4059 18.3614 12.0513L2.077 21.2112C0.9299 21.8564 0 21.3223 0 20.0176V1.74882C0 0.444395 0.9296 -0.0901857 2.077 0.555114L18.3614 9.71481Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_756_114135)">
        <path
          d="M10.5865 10.7138L16.4033 16.512L-0.973633 22.3103L10.5865 10.7138Z"
          fill="url(#paint3_linear_756_114135)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_756_114135"
          x1="5.871"
          y1="0.281394"
          x2="5.871"
          y2="8.53231"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBDA09" />
          <stop offset="1" stopColor="#FFBC00" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_756_114135"
          x1="-15.2435"
          y1="42.211"
          x2="14.6689"
          y2="41.1548"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#01E2FF" />
          <stop offset="1" stopColor="#01C4FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_756_114135"
          x1="-7.79445"
          y1="2.02941"
          x2="-0.998502"
          y2="17.2822"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#28D781" />
          <stop offset="1" stopColor="#02F076" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_756_114135"
          x1="-2.10212"
          y1="4.48481"
          x2="-7.49235"
          y2="24.8048"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F2414E" />
          <stop offset="1" stopColor="#E02554" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default GooglePlayLogo
